module.exports = __webpack_public_path__ + "static/media/logo-project42.4c15a0f2.png";